import { useIntl } from 'react-intl';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface ErrorFallbackUIProps {
  onRetry: () => void;
  onGoHome: () => void;
}

/**
 * Styled error fallback with i18n support.
 * Used inside IntlProvider — if IntlProvider fails,
 * the Sentry.ErrorBoundary in main.tsx catches it with a static fallback.
 */
export function ErrorFallbackUI({ onRetry, onGoHome }: ErrorFallbackUIProps) {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-8 text-center">
      <AlertTriangle className="w-16 h-16 text-destructive mb-6" />
      <h1 className="text-2xl font-bold mb-2">
        {intl.formatMessage({ id: 'errors.boundary.title' })}
      </h1>
      <p className="text-muted-foreground mb-6 max-w-md">
        {intl.formatMessage({ id: 'errors.boundary.description' })}
      </p>
      <div className="flex gap-3">
        <Button variant="outline" onClick={onRetry}>
          {intl.formatMessage({ id: 'errors.boundary.retry' })}
        </Button>
        <Button onClick={onGoHome}>
          {intl.formatMessage({ id: 'errors.boundary.goHome' })}
        </Button>
      </div>
    </div>
  );
}
